import moment from "moment";
import { formatMoney } from "../../features/utils/formatMoney";
import { getSupplierName } from "../flight/supplier/getSupplierName";
import { getSupplierClass } from "../../components/flight/FlightOfferDisplay";
import { flightStatusMap } from "../../pages/Orders/OrdersData";
import { alertType } from "../constants";
import Icon from "../../components/HOC/Icon";
import { Link } from "react-router-dom";
import { getStatusName } from "../flight/order/getStatusName";
import OrderStatus from "../../components/order/OrderStatus";
import { capitalize } from "lodash";
import {
  getFlightFareTypeCoverProps,
  getFlightFareTypeTagElement,
} from "./flightFareTypeTag";

export function templateFlightOrderRenameData(data) {
  const flightData = data?.flightBooking?.at(0);
  const fareTypeCover = getFlightFareTypeCoverProps(flightData);
  const newSegment = data?.newSegment;
  // debugger
  let flightType = "One Way";
  if (flightData?.destinations?.length) {
    flightType = "Multi City";
    if (
      flightData?.destinations?.at(-1)?.to ===
      flightData?.destinations?.at(0)?.from
    )
      flightType = "Return";
  }

  const newDirections = [
    ...new Set(
      data?.newDirections
        ?.map((direction) => direction?.departure)
        .filter((date) => Boolean(date)),
    ),
  ];
  const passengers = (data?.passengerInfo || [])?.map((obj) =>
    capitalize(
      [obj?.firstName, obj?.middleName, obj?.lastName]
        .filter((name) => Boolean(name))
        ?.join(" "),
    ),
  );

  let travelDateElements = [{ type: "title", value: "New Travel Date" }];

  for (const date of newDirections) {
    travelDateElements = [
      ...travelDateElements,
      {
        type: "text",
        value: moment(date).format("MMM DD YYYY"),
      },
    ];
  }

  let passengerElements = [{ type: "title", value: "Passenger" }];
  for (const passenger of passengers) {
    passengerElements = [
      ...passengerElements,
      {
        type: "text",
        value: passenger,
      },
    ];
  }

  return [
    {
      elements: [
        {
          type: "title",
          value: moment(data?.updatedAt)?.format("DD-MM-YYYY HH:mm [GMT]Z"),
        },
        {
          type: "copy",
          value: data?.orderId,
          // renderValue: () => <>{data?.orderId}</>
          renderValue: () => (
            <Link
              target="_blank"
              to={
                "/order/flight/ticket/rename/confirmation/" +
                (data?.status === "Success" ? "details/" : "") +
                data?._id
              }
            >
              {flightData?.bookingId}
            </Link>
          ),
        },
        {
          type: "tag",
          value: getSupplierName(flightData?.supplier),
          className: getSupplierClass(flightData?.supplier),
          color: "text-[#BD002A]",
          background: "bg-[#BD002A]/20",
        },
        {
          type: "title",
          value: "",
        },
        getFlightFareTypeTagElement(flightData),
      ],
      cover: (
        <div className="flex flex-col gap-2">
          <div className="flex gap-4 flex-1">
            <div className="flex-1 overflow-clip">
              <div className="whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[140px]">
                {flightData?.travelers
                  ?.filter((obj) => obj?.travelerType === "ADT")
                  ?.slice(0, 1)
                  ?.map(
                    (obj) =>
                      `${obj?.firstName} ${obj?.middleName || ""} ${
                        obj?.lastName
                      }`,
                  )
                  ?.join(", ")}
              </div>
              <div className="flex gap-2 items-center font-bold">
                <img
                  src={flightData?.flights?.at(0)?.airlineImage}
                  alt=""
                  className="!w-6 !h-10"
                />
                {flightData?.destinations
                  ?.slice(0, 1)
                  ?.map((obj) => `${obj?.from} - ${obj?.to}`)
                  ?.join(",") || ""}
              </div>
              <div>
                <span className="text-theme1">{flightData?.pnr}</span>
              </div>
            </div>
            <div
              className={`rounded-md mb-3 whitespace-nowrap flex flex-col gap-1 text-center`}
            >
              <span
                className={`text-xs px-2 rounded-md py-1 ${getSupplierClass(
                  flightData?.supplier,
                )}`}
              >
                {getSupplierName(flightData?.supplier)}
              </span>
              <span className={fareTypeCover.className}>
                {fareTypeCover.label}
              </span>
              <OrderStatus
                value={internalStatus(
                  data,
                  getStatusName(flightStatusMap(data?.status)),
                )}
              />
            </div>
          </div>
          <div>
            <small>
              {moment(data?.createdAt)?.format("DD-MM-YYYY HH:mm [GMT]Z")}
            </small>
            <p>
              <Link
                target="_blank"
                to={
                  "/order/flight/ticket/detail/" + data?._id + "?page=Tickets"
                }
              >
                {data?.orderId}
              </Link>
            </p>
          </div>
        </div>
      ),
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[25%]",
    },
    // {
    //   elements: [
    //     { type: "title", value: "Request Time" },
    //     { type: "text", value: moment(data?.updatedAt)?.format('YYYY-MM-DD HH:mm')},
    //   ],
    //   value: moment(data?.updatedAt)?.format('YYYY-MM-DD HH:mm'),
    //   width: "md:w-[20%]",
    // },

    {
      elements: [
        { type: "title", value: flightType },
        {
          type: "text",
          render: () => (
            <div>
              {flightData?.destinations
                ?.slice(0, 1)
                ?.map((obj) => `${obj?.from} - ${obj?.to}`)
                ?.join(",") || ""}
              <div>
                <span className="text-theme1">{flightData?.pnr}</span>
              </div>
              <small>{flightData?.flights?.at(0)?.airlineName}</small>
            </div>
          ),
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: travelDateElements,
      value: moment(flightData?.flights?.at(0)?.departureDate)?.format(
        "YYYY-MM-DD",
      ),
      width: "md:w-[15%]",
    },
    // {
    //   elements: [
    //     { type: "title", value: "GDS PNR" },
    //     { type: "copy", value: flightData?.pnr },
    //     { type: "title", value: "Airline PNR" },
    //     { type: "copy", value: flightData?.pnr },
    //   ],
    //   width: "md:w-[15%]",
    // },
    {
      elements: passengerElements,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Fee" },
        { type: "text", value: formatMoney(data?.payable) },
      ],
      value: flightData?.payable,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Status" },
        {
          type: "status",
          value: internalStatus(
            data,
            getStatusName(flightStatusMap(data?.status)),
          ),
          // render: () => {
          //   const status = flightStatusMap(data?.status);

          //   return (
          //       <div className={`rounded-md mb-3`}>
          //       <span
          //       className={`${alertType[data?.status?.toLowerCase()]} overflow-hidden text-ellipsis text-xs `}
          //       title={status}
          //       >
          //           {getStatusName(status)}
          //       </span>
          //       </div>
          //   )
          // }
        },
        // { type: "time", render: () => {
        //     const diffInSeconds = moment.utc(flightData?.ticketingExpiry).diff(moment.utc(), 'seconds');

        //     // Format the difference in the "5h 10m 5s" format
        //     const hours = Math.max(Math.floor(diffInSeconds / 3600),0);
        //     const minutes = Math.max(Math.floor((diffInSeconds % 3600) / 60),0);
        //     // const seconds = diffInSeconds % 60;

        //     return true ? (
        //         <div className={`flex gap-1 items-center text-sm ${hours || minutes ? '' :'text-red-500'}`}>
        //             <Icon icon='mdi:clock-outline' className='!w-4 !h-4' />
        //             {hours || minutes} {hours?'Hrs':'Mins'}
        //         </div>
        //     ):null
        // }},
      ],
      value: (function () {
        return [
          "Pending",
          "Denied",
          "Approved",
          "PendingChange",
          "PendingReissue",
        ]?.findIndex((val) => val === flightStatusMap(data?.status));
      })(),
      width: "md:w-[15%]",
    },
  ];
}

function internalStatus(order, status) {
  if (order?.status === "Approved" && order?.changePrice && !order?.isConfirmed)
    return "Awaiting Payment";
  return status;
}
// export enum ORDER_STATUS {
//   Approved = "Approved",
//   Paid = "Paid",
//   Denied = "Denied",
//   Pending = "Pending",
//   PendingPayment = "PendingPayment",
//   PendingVoid = "PendingVoid",
//   Success = "Success",
//   Failed = "Failed",
//   Closed = "Closed",
// }
